import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { InfoText } from '@mwe/models';
import { ButtonComponent } from '@mwe/ui/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-mvno-info-text-popup',
  templateUrl: './mvno-info-text-popup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslatePipe],
})
export class MvnoInfoTextPopupComponent {
  readonly loadedData = input.required<InfoText>();
  readonly onCloseClick = output<void>();
}
